import React, { useMemo, useState } from 'react'
import { HeaderWapper, Heading, Wapper } from '../style'
import BarComparisonChart from '../BarChart'
import { Select } from '@base'
import { strings } from '@constants'
import { mergeChartData } from '../Sales/EnquiryVsOrderChart'

const ORDER_TYPES = {
	Order_Converted: 'Order Converted',
	// Total_Order: 'Total Order',
}

let orderTypes = Object.values(ORDER_TYPES).map((i) => ({ order: i }))

const EnquiryVsOrder = ({ OrderConvertedData = [], TotalOrderData = [] }) => {
	const [orderData, updateOrderHandler] = useState(orderTypes[0])

	// const chartData = useMemo(() => mergeData(OrderConvertedData, TotalOrderData), [OrderConvertedData, TotalOrderData])
		const chartData = useMemo(
			() =>
				mergeChartData([
					{ key: 'enquiry', data: OrderConvertedData },
					{ key: 'order', data: TotalOrderData },
				]),
			[OrderConvertedData, TotalOrderData]
		)
	
		if (!chartData.length) return '-'
	return (
		<Wapper>
			<HeaderWapper JustifyStart>
				<Heading>Enquiry vs Order Converted</Heading>
				{/* <Select
					id='order'
					data={orderTypes}
					value={orderData?.order ? { order: orderData?.order } : {}}
					onChange={(e) => updateOrderHandler(e)}
					placeholder={strings('select', 'order')}
					displayKey='order'
					primaryKey='order'
				/> */}
			</HeaderWapper>

			{!!chartData.length && (
				<BarComparisonChart data={chartData} dataKeys={['enquiry', 'order']} ToolTipUnit={'MT'} colors={['#0043CE', '#4589FF']} />
			)}
		</Wapper>
	)
}

export default EnquiryVsOrder
